// external modules
import { useTranslation } from "react-i18next";
// components
import SubTitle from "../@common/SubTitle/SubTitle";
import Title from "../@common/Title/Title";
import ImageRenderer from "components/@common/ImageRenderer/ImageRenderer";
// styles & types & assets
import shampooAnalysis from "assets/img/@intro/shampoo-analysis.webp";
import styles from "./Step2.module.scss";

export default function Step2() {
  const { t } = useTranslation();
  return (
    <section className={styles["wrapper-step2"]}>
      <div className={styles["wrap-title"]}>
        <SubTitle>{t("지금 내가 쓰는 샴푸 과연 잘 맞을까?")}</SubTitle>
        <Title>{t("샴푸 궁합도 분석")}</Title>
      </div>
      <div className={styles["wrap-img"]}>
        <ImageRenderer src={shampooAnalysis} alt={"shampooAnalysis"} />
      </div>
    </section>
  );
}
